// filter in table grid
var $filterToggle = $('.filter__toggle');


if ($filterToggle.length) {
	var $filterParent = $filterToggle.closest('.grid-head');
	var $filterWrap = $filterParent.find('.search-body');

	// for first init
	$filterParent.addClass('filter filter--active');

	$filterToggle.on('click', function () {
		$filterParent.toggleClass('filter--active');
		$filterWrap.toggleClass('inactive');
	});
}


// added button to filter
function initButtonForInput() {
	var $this = $(this);
	$this.after('<button class="icon--calendar" id="' + $this.attr('id') + '_btn"></button>');
}

$('.grid-filter.field-datetime-filter').each(initButtonForInput);
$('.grid-filter.field-date-filter').each(initButtonForInput);

var fullTextFilterSelectedObserver = null;

function syncFullTextFilterSelectedForMobile() {
	var $source = $('#fullTextFilterSelected');
	var $target = $('.full-text-filter-selected-mobile');

	if (!$source.length || !$target.length) return;

	$target.html($source.html());
	$target.toggleClass('active', $source.hasClass('active'));
}

function initFullTextFilterSelectedObserver() {
	var sourceNode = document.getElementById('fullTextFilterSelected');
	if (!sourceNode) return;

	if (fullTextFilterSelectedObserver) {
		fullTextFilterSelectedObserver.disconnect();
	}

	fullTextFilterSelectedObserver = new MutationObserver(function () {
		syncFullTextFilterSelectedForMobile();
	});

	fullTextFilterSelectedObserver.observe(sourceNode, {
		childList: true,
		subtree: true,
		characterData: true,
		attributes: true
	});

	syncFullTextFilterSelectedForMobile();
}

// for mobiol
function initFilterForMobile() {
	if (!$('.cat-list__wrap').length) return;
	if (window.matchMedia("(min-width: 768px)").matches) {
		// remove button
		$('.filter-mobile-btn, #show-filtered-items, .full-text-filter-selected-mobile').remove();
		if (fullTextFilterSelectedObserver) {
			fullTextFilterSelectedObserver.disconnect();
			fullTextFilterSelectedObserver = null;
		}
		$('body').removeClass('overflow-hidden');
		$('body').removeClass('mobile-filter-on');
		return
	}

	const targetNode = document.getElementById('other_facets');
	if (targetNode) {
		const config = { childList: true, subtree: true };

		const callback = function(mutationsList, observer) {
			for(const mutation of mutationsList) {
				if (mutation.type === 'childList') {
					$('.dropdown__content').each(function () {
						var $this = $(this);
						if ($this.find('.ft-filter__title').length) {
							$this.addClass('dropdown__content--w-title');
						}
					});
				}
			}
		};

		const observer = new MutationObserver(callback);
		observer.observe(targetNode, config);
	}

	const iconFilter = '<svg width="100%" height="100%" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><path d="M516.544,769.831l-373.018,0c-8.569,0 -15.526,6.957 -15.526,15.526l0,31.051c0,8.569 6.957,15.525 15.526,15.525l373.018,0l0,0.067c14.304,55.04 64,96 123.456,96c59.456,0 109.152,-40.96 123.456,-96l0,-1.552c2.011,0.953 4.259,1.485 6.63,1.485l110.388,0c8.569,0 15.526,-6.956 15.526,-15.525l0,-31.051c0,-8.569 -6.957,-15.526 -15.526,-15.526l-110.388,0c-2.371,0 -4.619,0.533 -6.63,1.485l0,-3.316c-14.304,-55.04 -64,-96 -123.456,-96c-59.456,0 -109.152,40.96 -123.456,96l0,1.831Zm123.456,94.169c-35.112,-0.009 -64,-28.904 -64,-64.016c0,-35.118 28.898,-64.016 64.016,-64.016l0.016,0c35.112,0.009 64,28.904 64,64.016c0,35.118 -28.898,64.016 -64.016,64.016l-0.016,0Zm-379.456,-383.051l-117.018,-0c-8.569,-0 -15.526,6.957 -15.526,15.525l-0,31.052c-0,8.568 6.957,15.525 15.526,15.525l117.018,0l0,0.949c14.304,55.04 64,96 123.456,96c59.456,0 109.152,-40.96 123.456,-96l0,-0.949l373.018,0c8.569,0 15.526,-6.957 15.526,-15.525l-0,-31.052c-0,-8.568 -6.957,-15.525 -15.526,-15.525l-373.018,-0l0,-0.949c-14.304,-55.04 -64,-96 -123.456,-96c-59.456,0 -109.152,40.96 -123.456,96l0,0.949Zm123.456,95.051c-35.112,-0.009 -64,-28.904 -64,-64.016c0,-35.118 28.898,-64.016 64.016,-64.016l0.016,0c35.112,0.009 64,28.904 64,64.016c0,35.118 -28.898,64.016 -64.016,64.016l-0.016,0Zm132.544,-382.62l-373.018,-0c-8.569,-0 -15.526,6.957 -15.526,15.525l0,31.052c0,8.568 6.957,15.525 15.526,15.525l373.018,0l0,0.518c14.304,55.04 64,96 123.456,96c59.456,0 109.152,-40.96 123.456,-96l0,-2.003c2.011,0.953 4.259,1.485 6.63,1.485l110.388,0l0.201,-0.001c8.476,-0.107 15.325,-7.022 15.325,-15.524l-0,-31.052c-0,-8.568 -6.957,-15.525 -15.526,-15.525l-110.388,-0c-2.371,-0 -4.619,0.532 -6.63,1.485l-0,-2.865c-14.304,-55.04 -64,-96 -123.456,-96c-59.456,-0 -109.152,40.96 -123.456,96l-0,1.38Zm123.456,94.62c-35.112,-0.009 -64,-28.904 -64,-64.016c-0,-35.118 28.898,-64.016 64.016,-64.016l0.016,0c35.112,0.009 64,28.904 64,64.016c-0,35.118 -28.898,64.016 -64.016,64.016l-0.016,0Z" style="fill:currentColor;fill-rule:nonzero;"/></svg>';


	$('.filter-mobile-btn, #show-filtered-items, .full-text-filter-selected-mobile').remove();

	// button to header bottom
	$('.header__body').append('<button class="filter-mobile-btn header__button no-desktop" type="button" title="Filtry">' + iconFilter + '</button>');
	// button to body
	$('.search, .view-bestsellers #obal2').prepend('<div class="full-text-filter-selected-mobile"></div>');
	$('.search, .view-bestsellers #obal2').prepend('<button class="filter-mobile-btn btn no-desktop" type="button" title="Zobrazit Filtry">Zobrazit filtry ' + iconFilter + '</button>');
	$('.ft-filter__whisper').append('<button class="btn" id="show-filtered-items" type="button">Zobrazit výsledky</button>');
	$('body').addClass('mobile-filter-active');

	initFullTextFilterSelectedObserver();


}

$(document).on('click', '.filter-mobile-btn', function () {
	if ($('.cat-list__wrap').hasClass('active')) {
		$('.filter-mobile-btn').removeClass('active');
		$('.cat-list__wrap').removeClass('active');
		$('body').removeClass('mobile-filter-on');

		// problem with z-index of header
		setTimeout(function () {
			$('body').removeClass('overflow-hidden');
		}, 300);
	} else {
		$('.filter-mobile-btn').addClass('active');
		$('body').addClass('overflow-hidden mobile-filter-on');
		$('.cat-list__wrap').addClass('active');
		$('#navMobile, .main-nav, .header__search, #mobileSearch').removeClass('active');
		$('.header__user__loggedin').removeClass('pop-up--active');
	}
})

$(document).on('click', '#show-filtered-items', function () {
	$('.filter-mobile-btn').removeClass('active');
	$('.cat-list__wrap').removeClass('active');
	setTimeout(function () {
		$('body').removeClass('overflow-hidden mobile-filter-on');
	}, 300);
})

$(document).on('click', '.full-text-filter-selected-mobile .ft-whisper__remove', function (e) {
	e.preventDefault();

	var $selected = $(this).closest('.ft-whisper__selected');
	var inputId = $selected.attr('data-input-id');
	if (!inputId) return;

	var $sourceButton = $('#fullTextFilterSelected .ft-whisper__selected[data-input-id="' + inputId + '"] .ft-whisper__remove');
	if ($sourceButton.length) {
		$sourceButton.first().trigger('click');
	}
})

$(window).on('resize', $.debounce(200, initFilterForMobile));
initFilterForMobile();
